/**
 * Created by Sara Neale on 5/10/16.
 *
 */

(function () {
    'use strict';

    // @ngInject
    function BrochureVideoControllerCtor($modalInstance, $scope, $timeout,
                                        AnalyticsService,
                                        modalOpenSource) {
        this.$modalInstance = $modalInstance;
        this.__objectType = 'BrochureVideoController';

        var trackingStr = 'brochure video';
        if (modalOpenSource){
            trackingStr = modalOpenSource + ' ' + trackingStr;
        }
        AnalyticsService.trackPageView(this, trackingStr);

        var timeout = $timeout(function(){
            AnalyticsService.track(this, 'video watched 10s: ' + trackingStr);
        }.bind(this), 10 * 1000);

        var monitor = setInterval(function(){
            var elem = document.activeElement;

            if (elem && elem.id === 'js-brochure-video') {
                clearInterval(monitor);
                AnalyticsService.track(this, 'video started: brochure video');
            }
        }.bind(this), 200);

        $scope.$on('$destroy', function() {
            clearInterval(monitor);
        });

        $scope.$on('$destroy', function() {
            $timeout.cancel(timeout);
        });
    }

    Controllers.BrochureVideoController = Class(Controllers.BaseController, {
        constructor: BrochureVideoControllerCtor,

        close: function close() {
            this.$modalInstance.close();
        },

    });
}());